/**
 * Utilities for managing authentication tokens in localStorage (localhost mode only)
 * Uses a unique key to avoid conflicts with MSAL cache
 */

const LOCAL_TOKEN_KEY = '__DEV_AUTH_TOKEN__';

/**
 * Retrieves the authentication token from localStorage
 * @returns The token string, or null if not found
 */
export function getLocalToken(): string | null {
  try {
    return localStorage.getItem(LOCAL_TOKEN_KEY);
  } catch (error) {
    console.error('Failed to retrieve token from localStorage:', error);
    return null;
  }
}

/**
 * Stores the authentication token in localStorage
 * @param token - The JWT token to store
 */
export function setLocalToken(token: string): void {
  try {
    localStorage.setItem(LOCAL_TOKEN_KEY, token);
  } catch (error) {
    console.error('Failed to store token in localStorage:', error);
    throw new Error('Failed to save authentication token');
  }
}

/**
 * Removes the authentication token from localStorage
 */
export function clearLocalToken(): void {
  try {
    localStorage.removeItem(LOCAL_TOKEN_KEY);
  } catch (error) {
    console.error('Failed to clear token from localStorage:', error);
  }
}

/**
 * Checks if a token exists in localStorage
 * @returns true if token exists, false otherwise
 */
export function hasLocalToken(): boolean {
  return getLocalToken() !== null;
}
